import React, { useState } from 'react';
import "./landing.scss"

const Landing = () => {
    const [activeTab, setActiveTab] = useState('All');
    const [hovered, setHovered] = useState(false);

    const tabs = ['All', 'Star Enterprise', 'Education', 'Medical'];

    const avatarData = {
        'Star Enterprise': [
            { name: 'Mark', photo: `${process.env.PUBLIC_URL}/assets/mark.png`, url: "./mark" },
            { name: 'Joeie', photo: `${process.env.PUBLIC_URL}/assets/joi.png`, url: "./joeie"  },
            { name: 'Dila', photo: `${process.env.PUBLIC_URL}/assets/dila.png`, url: "./dilla"  },
        ],
        Education: [
            { name: 'Jason', photo: `${process.env.PUBLIC_URL}/assets/jason.png` , url: "./classroom/jason" },
            { name: 'Emily', photo: `${process.env.PUBLIC_URL}/assets/emily.png` , url: "./classroom/emily" }
        ],
        Medical: [
            { name: 'Sri', photo: `${process.env.PUBLIC_URL}/assets/sri.png` , url: "./hospital/sri" },
            { name: 'Jonathan', photo: `${process.env.PUBLIC_URL}/assets/jonathan.png`, url: "./hospital/jonathan"  }
        ]
    };

    const allAvatars = Object.values(avatarData).flat();
    const placeholderImage = 'path/to/placeholder.jpg';

    return (
        <div className={`landing ${hovered ? 'hovered' : ''}`}>
            
            <div className="video-overlay"></div>
            <div className="landing-tab">
                {tabs.map(tab => (
                    <div
                        key={tab}
                        className={`landing-tab_item ${activeTab === tab ? 'active' : ''}`}
                        onClick={() => setActiveTab(tab)}
                    >
                        {tab}
                    </div>
                ))}
            </div>
            <div className="landing-body">
                {(activeTab === 'All' ? allAvatars : avatarData[activeTab]).map((avatar, index) => (
                    <div
                        key={index}
                        className="avatar-card"
                        onMouseEnter={() => setHovered(true)}
                        onMouseLeave={() => setHovered(false)}
                        onClick={() => window.location.href = `${avatar.url}`}
                    >
                        <img src={avatar.photo || placeholderImage} alt={avatar.name} />
                        <div>{avatar.name}</div>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default Landing;